<script setup>
//region Imports
import { ref, onMounted, reactive } from 'vue'
import StepHeader from '../components/StepHeader.vue'
import config from "../config/index.js";
//endregion
//region Methods
const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))
const readSelectedItems = () => JSON.parse(localStorage.getItem('tc-claim-selected-items'))
const readCustomerInformation = () => JSON.parse(localStorage.getItem('tc-claim-customer-information'))
let showNeedHelp = ref(false)
let needHelpNotes = ref('')

const acknowledge = () => {
  location.replace('#/order')
}

const clickToContinue = () => {

  console.log('needHelpNotes: ',needHelpNotes)

  fetch(`${config.cloud.url}/api/shopify/order/shipping-protection/claims`, {
    mode: 'cors',
    method: 'POST',
    cache: 'no-cache',
    redirect: 'follow',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      reason: 'other',
      orderId: data?.shopifyOrderId,
      userAgent: navigator.userAgent,
      orderNumber: orderNumber?.value,
      customerNotes: needHelpNotes?.value,
      customerEmail: customerInformation?.email ?? data?.customerEmail,
      customerName: customerInformation?.firstName + ' ' + customerInformation?.lastName,
    }),
  }).
  then(response => response.json()).
  then(data => {
    if (!data?.success) {
      alert('An error occurred while submitting your message. Please try again later.')
      return data
    }

    location.replace('#/claim/success')
  }).
  catch(error => console.error(new Error(error)))

}

const clickToCancel = () => location.replace('#/order/track')
//endregion
//region Variables
const data = reactive(readData() ?? {})
const items = reactive(readSelectedItems() ?? [])
const orderNumber = ref(data?.orderNumber)
const customerInformation = reactive(readCustomerInformation() ?? {})
//endregion
//region Lifecycle
onMounted(() => {
  if (!orderNumber.value) {
    location.replace('/')
  }
})
//endregion
</script>

<template>

  <figure class="w-full h-[305px] overflow-hidden bg-no-repeat bg-right bg-cover"
          style="background-image: url(https://cdn.shopify.com/s/files/1/0067/9532/9609/files/DSC01071.png?v=1713213218);">&nbsp;</figure>

  <div class="p-5">

    <step-header :data="data" :items="items"/>

    <main class="max-w-6xl mx-auto">

      <div class="flex flex-row mb-5">
        <button type="button" @click="clickToCancel">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path d="M8 7L2 13L8 19" stroke="black" stroke-width="1.5"/>
          </svg>
        </button>
        <h1 class="font-bold text-xl font-minionpro" v-text="`Not yet our friend`"></h1>
      </div>

      <p class="leading-relaxed">
        You will be eligible to file a claim on <strong>02/17/2024 at 10:21 AM</strong>.
      </p>

      <p class="leading-relaxed mt-2">
        To file a claim, you must fall within our claim policy. The claim filing window opens 4 days after your package
        was marked as delivered by the carrier.
      </p>

      <div class="grid grid-col-1 gap-5 my-10">
        <button
            type="button"
            @click="acknowledge"
            class="w-full border py-2.5 px-8 bg-tc-maroon text-white border-tc-maroon"
        >Okay
        </button>

        <button
            type="button"
            @click="showNeedHelp = !showNeedHelp"
            class="w-full py-2.5 px-8 border border-tc-creme text-tc-creme"
            v-if="!showNeedHelp"
        >I still need help
        </button>

        <div v-if="showNeedHelp">
          <textarea v-model="needHelpNotes"
                    class="bg-tc-off-white w-full h-48 border-0 placeholder-tc-creme"
                    placeholder="How can we help?"
          ></textarea>
          <button type="submit"
                  class="w-full py-2.5 px-8 border border-tc-creme text-tc-creme"
                  @click="clickToContinue"
          >
          Submit
          </button>
        </div>
      </div>

    </main>

  </div>

</template>

<style scoped>
</style>